import {Component, OnDestroy, OnInit} from "@angular/core";
import {ActionsService} from "../../Redux/Actions/actions.service";
import {ApplicationCatalogActions} from "../../Redux/Actions/application-catalog-actions";
import {select} from "@angular-redux/store";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActivatedRoute, Router} from "@angular/router";
import {ISpec} from "../../models/ISpec";
import {isNull, isNullOrUndefined} from "util";
import {IAppTypeMap, Ic, IDesignSolution, IEntityAlert} from "../../models/common";
import {MainViewType} from "../../models/view";
import {AnalyticsActions} from "../../Redux/Actions/analytics.actions";
import {Observable, Subject} from "rxjs";
import {combineLatest, takeUntil} from "rxjs/operators";
import {TranslateService} from "@ngx-translate/core";
import {support_to_url} from "../../common/utils";

@Component({
  selector: "edsng-selected-design",
  templateUrl: "./selected-design.component.html",
  styleUrls: ["./selected-design.component.css"]
})
export class SelectedDesignComponent implements OnInit, OnDestroy {
  @select(["appProjectTypes", "appTypeMap"]) appTypeMap$;
  @select(["appCatalog", "selectedSolution"]) selectedSolution$;
  @select(["appSpec", "spec", "value"]) valueSpec$;
  @select(["appSpec", "noteGlobal"]) noteGlobal$: Observable<IEntityAlert>;
  @select(["appCatalog", "appClass"]) appName$;
  @select(["appToolBar", "viewType"]) viewType$;

  componentDestroyed: Subject<any> = new Subject();

  itemSpec: ISpec<number>;
  typeMap: IAppTypeMap;
  noteGlobal: IEntityAlert;
  selectedSolution: Ic;
  appName: string;

  errorSpecification: boolean = true;

  constructor(
    public act: ActionsService,
    public snack: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.route.params.pipe(takeUntil(this.componentDestroyed)).subscribe(x => {
      this.act.sendAction(
        ApplicationCatalogActions.selectSolutionByKey(x["ic"])
      );
    });
    this.selectedSolution$.pipe(
      takeUntil(this.componentDestroyed),
      combineLatest(this.viewType$)
    ).subscribe(([solution, viewType]) => {
      this.selectedSolution = solution;
      if (isNull(solution)) {
        this.router.navigate(
          ["./" + (viewType === MainViewType.GRID ? "grid" : "list")],
          {relativeTo: this.route.parent}
        );
      }
    });
    this.valueSpec$.pipe(
      takeUntil(this.componentDestroyed)
    )
      .subscribe(x => (this.itemSpec = x));
    this.appTypeMap$.pipe(
      takeUntil(this.componentDestroyed)
    )
      .subscribe(y => (this.typeMap = y));
    this.noteGlobal$.pipe(takeUntil(this.componentDestroyed)).subscribe(z => {
      this.noteGlobal = z;
      this.errorSpecification = this.noteGlobal.hasError;
    });
    this.appName$.pipe(
      takeUntil(this.componentDestroyed)
    )
      .subscribe(w => (this.appName = w));
  }

  ngOnDestroy() {
    this.componentDestroyed.next();
    this.componentDestroyed.unsubscribe();
  }

  deselectIC(event): void {
    this.act.sendAction(ApplicationCatalogActions.deselectSolution());
  }

  onOpenDS(item: IDesignSolution) {
    const dsUrl = support_to_url('datasheet', this.translate.currentLang) + item.RPN + '.pdf';
    this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
      'open_datasheet',
      'redirect',
      {
        details: dsUrl,
        topology: item.topology,
        cpn: (item as Ic).CPN,
        tag: "selected"}));
  }

  onOpenPF(item: IDesignSolution) {
    const pfUrl = support_to_url('product_folder', this.translate.currentLang) + item.RPN;
    this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
      'open_product_folder',
      'redirect',
      {
        details: pfUrl,
        topology: item.topology,
        cpn: (item as Ic).CPN,
        tag: "selected"}));
  }
}
